export const SPRITE_CONTAINER_ID = 'app-icon-sprite'
export const SPRITE_SYMBOL_PREFIX = 'app-icon-'

export const getSpriteSymbolId = (id: string): string =>
  `${SPRITE_SYMBOL_PREFIX}${id}`

/**
 * Prefixes `<symbol>` ids so the inline sprite cannot clash with DOM ids used
 * by the app (e.g. `#share` is a tour guide target) and strips the root
 * `class` attribute.
 */
export const prepareSpriteMarkup = (markup: string): string =>
  markup
    .replace(/<svg\b[^>]*>/, (root) => root.replace(/\s+class="[^"]*"/, ''))
    .replace(
      /(<symbol\b[^>]*?\sid=)(["'])(.*?)\2/g,
      (_, start: string, quote: string, id: string) =>
        `${start}${quote}${getSpriteSymbolId(id)}${quote}`,
    )

/**
 * Inserts the sprite into the document once. Same-document `<use href="#id">`
 * renders synchronously, unlike an external sprite URL, which WebKit
 * (iOS WKWebView) re-resolves on every mount and briefly shows empty icons.
 */
export const mountSprite = (doc: Document, markup: string): void => {
  if (doc.getElementById(SPRITE_CONTAINER_ID)) return

  const container = doc.createElement('div')
  container.id = SPRITE_CONTAINER_ID
  container.setAttribute('aria-hidden', 'true')
  // Not display: none — that breaks clipPath/gradient references in WebKit.
  container.style.cssText =
    'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none'
  container.innerHTML = prepareSpriteMarkup(markup)

  doc.body.prepend(container)
}
